import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

import { DefaultRootStateProps } from 'types';
import { IProjectReleases } from 'types/views/releases';

const initialState: DefaultRootStateProps['releases'] = {
    isLoading: true,
    releases: null,
    appVersion: null
};

const slice = createSlice({
    name: 'releases',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getReleasesList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getReleasesList.fulfilled, (state, action) => {
                state.isLoading = false;
                let releases: IProjectReleases[] = action.payload;
                state.releases = releases.sort(function (a, b) {
                    return new Date(b.published_at).getTime() - new Date(a.published_at).getTime();
                });
            })
            .addCase(getLatestVerion.fulfilled, (state, action) => {
                state.appVersion = action.payload.version;
            });
    }
});

// Reducer
export default slice.reducer;

export const getReleasesList = createAsyncThunk(`${slice.name}/releases`, async () => {
    const response = await axios.get(`/loolu/api/releases`, {});
    return response.data;
});

export const getLatestVerion = createAsyncThunk(`${slice.name}/latestVersion`, async () => {
    const response = await axios.get(`/loolu/api/releases/latest-version`, {});
    return response.data;
});
